// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 615 ? "c11801cb" : chunkId) + "." + {"487":"368b81ae881d632f","615":"84397cce73f9c7de","807":"10458089cb3360b6"}[chunkId] + ".js";
};